import React from 'react';

const ChatInput = ({ userInput, setUserInput, handleKeyDown, loading, sendMessage, setOpenStar, openStar }) => {
    return (
        <div className={`chatbot-input`}>
            <div className="chatbot-input-flex">
                <textarea
                    className="text"
                    placeholder="Nhập câu hỏi của bạn tại đây..."
                    type="text"
                    id="message"
                    name="message"
                    value={userInput}
                    onChange={(e) => setUserInput(e.target.value)}
                    onKeyDown={handleKeyDown}
                    // onKeyUp={() => setOpenStar({ ...openStar, status: false })}
                    disabled={loading}
                ></textarea>
                <button
                    className={`button`}
                    onClick={sendMessage}
                    disabled={loading}
                >
                    <svg
                        id="paper-plane"
                        xmlns="http://www.w3.org/2000/svg"
                        width="25.55"
                        height="24.07"
                        viewBox="0 0 25.55 24.07"
                    >
                        <path
                            id="Path_465"
                            data-name="Path 465"
                            d="M12.207,13.766,8.71,12.3a.7.7,0,0,0-.652.063.693.693,0,0,0-.309.577v5.312a.692.692,0,0,0,.443.646.681.681,0,0,0,.25.047.692.692,0,0,0,.513-.228l3.5-3.849a.693.693,0,0,0-.246-1.105Z"
                            transform="translate(0.5 0.791)"
                            fill="#fff"
                            opacity="0.8"
                        ></path>
                        <path
                            id="Path_466"
                            data-name="Path 466"
                            d="M25.294.213a.8.8,0,0,0-.832-.159L.509,9.369a.8.8,0,0,0,.005,1.49l18.9,7.186a.819.819,0,0,0,.284.052.8.8,0,0,0,.764-.564l5.057-16.5a.8.8,0,0,0-.221-.82Z"
                            transform="translate(0 0)"
                            fill="#fff"
                            opacity="0.51"
                        ></path>
                        <path
                            id="Path_467"
                            data-name="Path 467"
                            d="M7.75,13.516,19.726,5l-8.96,9.936Z"
                            transform="translate(0.5 0.323)"
                            fill="#fff9f2"
                            opacity="0.45"
                        ></path>
                        <path
                            id="Path_468"
                            data-name="Path 468"
                            d="M19.694,18.1a.819.819,0,0,1-.284-.052L.514,10.86a.8.8,0,0,1,0-1.49L24.462.054a.8.8,0,0,1,1.052.978l-5.057,16.5a.8.8,0,0,1-.763.564ZM3.023,10.1l16.158,6.145L23.5,2.14Z"
                            transform="translate(0 0)"
                            fill="#fff"
                        ></path>
                        <path
                            id="Path_469"
                            data-name="Path 469"
                            d="M8.548,20.227a.8.8,0,0,1-.8-.8V13.307a.8.8,0,0,1,.3-.625L23.752.174a.8.8,0,0,1,1,1.25L9.347,13.691v3.671l2.641-2.906a.8.8,0,0,1,1.182,1.073l-4.03,4.436a.8.8,0,0,1-.591.262Z"
                            transform="translate(0.5 0)"
                            fill="#fff"
                        ></path>
                        <path
                            id="Path_470"
                            data-name="Path 470"
                            d="M8.034,20.006a.791.791,0,0,1-.441-.133.8.8,0,0,1-.224-1.107c.313-.471.492-.815.5-.832a.8.8,0,0,1,1.421.729,11.183,11.183,0,0,1-.592.988.8.8,0,0,1-.666.356Z"
                            transform="translate(0.467 1.13)"
                            fill="#fff"
                        ></path>
                        <path
                            id="Path_471"
                            data-name="Path 471"
                            d="M2.957,22.79a.833.833,0,0,1-.209-.028,3.281,3.281,0,0,1-2.186-1.8A.8.8,0,0,1,2,20.269a1.678,1.678,0,0,0,1.165.954.8.8,0,0,1-.21,1.567Zm2.213-.005a.8.8,0,0,1-.247-1.559,4.228,4.228,0,0,0,1.571-1.016A.8.8,0,0,1,7.6,21.365a5.808,5.808,0,0,1-2.182,1.382.806.806,0,0,1-.247.038Z"
                            transform="translate(0.031 1.279)"
                            fill="#fff"
                        ></path>
                        <path
                            id="Path_472"
                            data-name="Path 472"
                            d="M.829,19.412a.8.8,0,0,1-.8-.746C.012,18.318,0,17.944,0,17.548a.8.8,0,1,1,1.6,0q0,.538.03,1.013a.8.8,0,0,1-.744.848Z"
                            transform="translate(0 1.081)"
                            fill="#fff"
                        ></path>
                    </svg>
                </button>
            </div>
        </div>
    );
};

export default ChatInput;
